import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/fontawesome-free-solid'
import "./Shop.css"

const Shop = () => {
    return (
        <>
            <h2 className='shophead'>
                SHOP OUR FAVOURITES
            </h2>
            <div className='cards'>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/files/IMG-8007_2_copy_1500x2200_e58a6674-103a-40d6-9ebf-4cb61f20c87c_600x.jpg?v=1720164953' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/products/ferocover2_600x.jpg?v=1667225612' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/files/2_71_badc6606-114c-4bab-8824-a690db4f2783_600x.png?v=1726141984' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/files/12_143acfcc-53b6-439f-b1ed-90073a1065f0_600x.png?v=1728366536' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/files/8_16_1e059411-1a60-4957-8311-f4e7b00345e0_600x.png?v=1719493043' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/files/41_600x.png?v=1721126582' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/files/1A7A9452-2_600x.jpg?v=1721135700' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <img src='https://rashki.com/cdn/shop/files/2_ad2805eb-27d1-484a-8474-6d8718212958_600x.png?v=1728365251' />
                    <div className='cardDetails'>
                        <div className='prodName'>
                            ARIA LAPTOP BAG
                        </div>
                        <div className='reviews'>
                            <div className='icons'>


                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            103 REVIEWS
                        </div>
                        <div className='price'>
                            RS. 3,799.00 <s>RS. 8,000.00</s>
                        </div>
                        <div className='off'>
                            52% Off
                        </div>
                        <div className='shopBtn'>
                            <button>ADD TO CART</button>
                        </div>
                    </div>
                </div>

            </div>
            <div className='shopBtn prodBtn'>
                <button>VIEW ALL PRODUCTS</button>
            </div>
        </>
    )
}

export default Shop